<mat-card class="mat-elevation-z0">
    <div fxLayout="row" fxLayoutAlign="space-between center">
        <h2 class="cardHeader">Pedidos recientes</h2>
        <button mat-icon-button (click)="refreshOrders()">
            <mat-icon class="refresh-icon">refresh</mat-icon>
        </button>
    </div>
</mat-card>
<!-- Table -->
<table mat-table [dataSource]="lastFiftyOrders" class="mat-elevation-z0">

    <ng-container matColumnDef="id">
        <th mat-header-cell *matHeaderCellDef class="table-header">ID</th>
        <td mat-cell *matCellDef="let item" class="table-content">{{item.cdOrder}}</td>
    </ng-container>

    <ng-container matColumnDef="store">
        <th mat-header-cell *matHeaderCellDef class="table-header">TIENDA</th>
        <td mat-cell *matCellDef="let item" class="table-content">
            {{item.dsStoreName}}
            <br>
            <p class="take-away">Retirar</p>
        </td>
    </ng-container>

    <ng-container matColumnDef="user">
        <th mat-header-cell *matHeaderCellDef class="table-header">USUARIO</th>
        <td mat-cell *matCellDef="let item" class="table-content">
            {{item.dsName}}
            <br>
            {{item.dsPhone}}
        </td>
    </ng-container>

    <ng-container matColumnDef="address">
        <th mat-header-cell *matHeaderCellDef class="table-header">DIRECCIÓN</th>
        <td mat-cell *matCellDef="let item" class="table-content">{{item.dsAddress}}</td>
    </ng-container>

    <ng-container matColumnDef="status">
        <th mat-header-cell *matHeaderCellDef class="table-header">ESTADO</th>
        <td mat-cell *matCellDef="let item" class="table-content">
            <div>
                <p [ngClass]="getTextColor(item.nmStatus)" class="status-text">{{item.nmStatus | ordersStatus}}</p>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="payment">
        <th mat-header-cell *matHeaderCellDef class="table-header">PAGO</th>
        <td mat-cell *matCellDef="let item" class="table-content">
            <p class="payment-text">Envío: {{item.qtDCharges}}</p>
            <p class="payment-text">Neto: {{item.qtTotal}}</p>
            <p class="payment-text">Total: {{item.qtDCharges + item.qtTotal}}</p>
            <div class="method-chip">
                <p class="method-text"
                    [ngClass]="{'card-text': item.nmPaymentMethod == 1, 'cash-text': item.nmPaymentMethod == 0}">
                    {{item.nmPaymentMethod | paymentMethod}}
                </p>
            </div>
        </td>
    </ng-container>

    <ng-container matColumnDef="time">
        <th mat-header-cell *matHeaderCellDef class="table-header">HORA DE PEDIDO</th>
        <td mat-cell *matCellDef="let item" class="table-content">{{ item.dtCreatedAt | date:'short' }}</td>
    </ng-container>

    <ng-container matColumnDef="action">
        <th mat-header-cell *matHeaderCellDef class="table-header">ACCIÓN</th>
        <td mat-cell *matCellDef="let item" class="table-content">
            <button mat-button [matMenuTriggerFor]="menu" class="squared-btn"
                *ngIf="item.nmStatus === 0">Opciones</button>
            <mat-menu #menu="matMenu">
                <button mat-menu-item (click)="confirmOrder(item.cdOrder)">Aceptar en comercio</button>
                <button mat-menu-item (click)="cancelOrder(item.cdOrder)">Anular orden</button>
                <button mat-menu-item (click)="printTicket(item.cdOrder)">Imprimir ticket</button>
            </mat-menu>
        </td>
    </ng-container>

    <tr mat-header-row *matHeaderRowDef="displayedColumns"></tr>
    <tr mat-row *matRowDef="let row; columns: displayedColumns;"></tr>
</table>